import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import App from "./App";
import "./styles.css";

// 注册静态资源自动更新，不缓存学生自由文本和 AI 请求。
registerSW({ immediate: true });

// 挂载单页学习体验。
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
